if($('body:not(.ordering-process)').length){
  $('body').append('<div class="hodnoceni-eshopu"><div class="left"><div class="top"></div><div class="bottom"><a href="/hodnoceni-obchodu/">Hodnocení</a></div></div><div class="link"><a href="/hodnoceni-obchodu/" class="hodnoceni-link">Zobrazit hodnocení obchodu</a></div></div>')

}

$(document).ready(function() {
  var storedDataRating = sessionStorage.getItem('hodnoceni');
  if (storedDataRating) {
      $('.hodnoceni-eshopu .left .top').append(storedDataRating);
  } else {
      $.ajax({
          url: '/hodnoceni-obchodu/',
          type: 'GET',
          success: function(responseData) {
              var content = $(responseData);
              console.log('content')
              var rateAverageInner = content.find('.rate-average-inner .rate-average').html().trim();
              var rateStarWrapStar = content.find('.rate-star-wrap .stars').html();
              var rateStarWrapStarsLabel = content.find('.rate-star-wrap .stars-label').html();
              var percentilRating = Math.floor(100*parseFloat(rateAverageInner)/5)
              var ratingsFinal = content.find('.votes-wrap').html();
            
              var finalHtmlRating = '<div class="rate-average-inner">'
              finalHtmlRating += '<div class="rate-average">'+rateAverageInner+'</div>'
              finalHtmlRating += '<span class="rate-star-wrap"><span class="stars">'+rateStarWrapStar+'</span></span>'
              finalHtmlRating += '<div class="text-center"><a href="/hodnoceni-obchodu/">'+rateStarWrapStarsLabel.split('(')[0].trim()+'</a></div>'
             // finalHtmlRating += '</div>'
              $('.hodnoceni-eshopu .left .top').append(finalHtmlRating)

              sessionStorage.setItem('hodnoceni', finalHtmlRating);
          },
          error: function(xhr, status, error) {
              console.error("Error fetching rating data:", status, error);
          }
      });
  }
});